import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const contactsecurityrole = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/contact-security-role',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'contactsecurityrole' }
    ),
    { }
  )
)()

export { contactsecurityrole, TYPES }
